import urls from '../api_urls/introVideo'
import { _post } from '@/axios/request'

// 获取video列表
export function getVideoData (params) {
  return _post(urls.GET_VIDEO_LIST, params)
}

// 增加视频点击量
export function addVideoClick (params) {
  return _post(urls.ADD_VIDEO_CLICK, params)
}

// 查询menu
export function getWebinarMenuList () {
  return _post(urls.GET_WEBINAR_MENU, {"parentId": 274})
}

// 获取webinar列表
export function getWebinarData (params) {
  return _post(urls.GET_WEBINAR_LIST, params)
}

// webinar详情
export function getWebinarDetail (params) {
  return _post(urls.GET_WEBINAR_DETAIL, params)
}

// 保存subscriber
export function saveSubscriber (params) {
  return _post(urls.SAVE_SUBSCRIBER, params)
}

// 获取subList
export function getSubData (params) {
  return _post(urls.GET_SUB_LIST, params)
}

// 获取用户详情
export function getUserDetail (params) {
  return _post(urls.GET_USER_DETAIL, params)
}

// 更新用户信息
export function updateUser (params) {
  return _post(urls.UPDATE_USER, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/introVideo.js